import * as React from "react";

import { HeroImage } from "components/shared/StorefrontWizard/HeroImage/HeroImage";
import {
  TabbedWizardCard,
  WizardRegionType,
} from "components/shared/StorefrontWizard/TabbedWizardCard/TabbedWizardCard";
import { WizardHeroProps } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { LobQueryRouterv2 } from "components/shared/StorefrontWizard/LobQueryRouter";

export interface WizardWithHeroImageProps extends WizardHeroProps {}

export const WizardWithHeroImage: React.FC<WizardWithHeroImageProps> = ({
  wizardLOBs,
  wizardFormChildren,
  trackOnChangeTab,
  context,
  heroImageFigureClassNames,
  heroImageSrc,
  heroImageColor,
  wizardState,
  aboveOtherFormChildren,
  belowOtherFormChildren,
}) => {
  const customStyle = heroImageColor ? { backgroundColor: heroImageColor } : undefined;
  return (
    <div style={customStyle}>
      <HeroImage className={heroImageFigureClassNames} src={heroImageSrc} alt="" context={context}>
        {aboveOtherFormChildren}
        <LobQueryRouterv2 lobs={wizardLOBs} />
        <TabbedWizardCard
          context={context}
          wizardFormChildren={wizardFormChildren}
          wizardState={wizardState}
          wrappingClassNames="all-t-padding-twelve all-x-padding-six SimpleContainer"
          tabGroupClassNames="formAlignedTabs all-x-padding-six"
          wizardFormClassNames="wizardOverHeroImage all-x-padding-six"
          trackOnChangeTab={trackOnChangeTab}
          wizardRegionType={WizardRegionType.BEX}
        />
        {belowOtherFormChildren}
      </HeroImage>
    </div>
  );
};
